import { ClassroomRoutes } from "../classroom/classroom-routes";
import { ClassroomComponent } from "../classroom/components/classroom.component";
import { ClassroomModule } from "../classroom/classroom.module";

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "../dashboard/components/dashboard.component";
import { DashboardMainComponent } from "../dashboard-main/components/dashboard-main/dashboard-main.component";
import { TestPageComponent } from "../test-page/components/test-page.component";

import { MasterComponent } from "./components/master.component";

import { DashboardModule } from "../dashboard/dashboard.module";
import { DashboardMainModule } from "../dashboard-main/dashboard-main.module";
import { AuthguardService, MenuService, MenuResolve } from "./services";

import { StudentComponent } from "../student/components/student.component";
import { StudentRoutes } from "../student/student-routes";
import { StudentModule } from "../student/student.module";

import { IDAdminRoutes } from "../IDAdmin/IDAdmin-routes";
import { IDAdminComponent } from "../IDAdmin/components/IDAdmin.component";
import { IDAdminModule } from "../IDAdmin/IDAdmin.module";

import { IDStationRoutes } from "../IDStation/IDStation-routes";
import { IDStationComponent } from "../IDStation/components/IDStation.component";
import { IDStationModule } from "../IDStation/IDStation.module";

import { OneCardExpressRoutes } from "../OneCardExpress/OneCardExpress-routes";
import { OneCardExpressComponent } from "../OneCardExpress/components/OneCardExpress.component";
import { OneCardExpressModule } from "../OneCardExpress/OneCardExpress.module";

import { VisitorRoutes } from "../Visitor/Visitor-routes";
import { VisitorComponent } from "../Visitor/components/Visitor.component";
import { VisitorModule } from "../Visitor/Visitor.module";

import { ExpressIDCardPrintingRoutes } from "../ExpressIDCardPrinting/ExpressIDCardPrinting-routes";
import { ExpressIDCardPrintingComponent } from "../ExpressIDCardPrinting/components/ExpressIDCardPrinting.component";
import { ExpressIDCardPrintingModule } from "../ExpressIDCardPrinting/ExpressIDCardPrinting.module";

import { DynamicReportRoutes } from "../dynamicreport/dynamicreport-routes";
import { DynamicReportComponent } from "../dynamicreport/components/dynamicreport.component";
import { DynamicReportModule } from "../dynamicreport/dynamicreport.module";

import { GroupsRoutes } from "../groups/groups-routes";
import { GroupsComponent } from "../groups/components/groups.component";
import { GroupsModule } from "../groups/groups.module";

import { ReportRoutes } from "../Report/report-routes";
import { ReportComponent } from "../Report/components/report.component";
import { ReportModule } from "../Report/report.module";

import { StaffComponent } from "../staff";
import { StaffRoutes } from "../staff/staff-routes";
import { StaffModule } from "../staff/staff.module";

import { SchoolSettingsComponent } from "../adminsettings";
import { SchoolSettingsRoutes } from "../adminsettings/adminsettings-routes";
import { SchoolSettingsModule } from "../adminsettings/adminsettings.module";

import { AdminSetupComponent } from "../adminsetup";
import { AdminSetupRoutes } from "../adminsetup/adminsetup-routes";
import { AdminSetupModule } from "../adminsetup/adminsetup.module";

import { SysAdminComponent } from "../sysadmin/components/sysadmin.component";
import { SysAdminRoutes } from "../sysadmin/sysadmin-routes";
import { SysAdminModule } from "../sysadmin/sysadmin.module";

import { DistrictAdminComponent } from "../siteadmin/components/districtadmin.component";
import { DistrictAdminRoutes } from "../siteadmin/districtadmin-routes";
import { DistrictAdminModule } from "../siteadmin/districtadmin.module";

import { AdminComponent } from "../admin";
import { AdminRoutes } from "../admin/admin-routes";
import { AdminModule } from "../admin/admin.module";

import { ScanPointModule } from "../ScanPoint/scan-point.module";
import { ScanPointRoutes } from "../ScanPoint/scan-point-routes";
import { ScanPointComponent } from "../ScanPoint/components/scanpoint.component";

import { SectionModule } from "../section/section.module";
import { SectionRoutes } from "../section/section-routes";
import { SectionComponent } from "../section/section/section.component";

import { SchoolSearchModule } from "../schoolsearch/schoolsearch.module";
import { SchoolSearchComponent } from "../schoolsearch/components/school-search.component";
import { SchoolSearchRoutes } from "../schoolsearch/schoolsearch-routes";

import { BusTrackerComponent } from "../bustracker/components/bustracker.component";
import { BusTrackerRoutes } from "../bustracker/bus-tracker-routes";
import { BusTrackerModule } from "../bustracker/bus-tracker.module";

import { HallSweepComponent } from "../hallsweep/components/hall-sweep.component";
import { HallSweepRoutes } from "../hallsweep/hall-sweep-routes";
import { HallSweepModule } from "../hallsweep/hall-sweep.module";

import { DashboardVisitorComponent } from "../dashboard-visitor/components/dashboard-visitor.component";
import { DashboardVisitorRoutes } from "../dashboard-visitor/dashboard-visitor-routes";
import { DashboardVisitorModule } from "../dashboard-visitor/dashboard-visitor.module";

import { Vpp3Component } from "../vpp3/components/vpp3.component";
import { Vpp3Routes } from "../vpp3/vpp3-routes";
import { Vpp3Module } from "../vpp3/vpp3.module";

import { VisitorMultiStationComponent } from "../visitor-multistation/components/visitor-multistation.component";
import { VisitorMultiStationRoutes } from "../visitor-multistation/visitor-multistation-routes";
import { VisitorMultiStationModule } from "../visitor-multistation/visitor-multistation.module";

import { DashboardMultiStationComponent } from "../dashboard-multistation/components/dashboard-multistation.component";
import { DashboardMultiStationRoutes } from "../dashboard-multistation/dashboard-multistation-routes";
import { DashboardMultiStationModule } from "../dashboard-multistation/dashboard-multistation.module";

import { ReportInboxMainComponent } from "../report-inbox/components/report-inbox-main.component";
import { ReportInboxRoutes } from "../report-inbox/report-inbox-routes";
import { ReportInboxModule } from "../report-inbox/report-inbox.module";
import { TestPageRoutes } from "../test-page/test-page-routes";
import { TestPageModule } from "../test-page/test-page.module";
import { PortalAppsComponent } from "../portal-apps/components/portal-apps.component";
import { PortalAppsRoutes } from "../portal-apps/portal-apps-routes";
import { PortalAppsModule } from "../portal-apps/portal-apps.module";

const routes: Routes = [
	//{path:'', data:{name:'dashboardroute'},component:DashboardComponent},

	{
		path: "",
		component: MasterComponent,
		resolve: {
			menu: MenuResolve,
		},
		children: [
			// {
			//   path: "",
			//   data: { title: "Dashboard" },
			//   component: DashboardComponent,
			//   canActivate: [AuthguardService]
			// },
			{
				path: "",
				data: { title: "Dashboard" },
				component: DashboardMainComponent,
				canActivate: [AuthguardService],
			},
			{
				path: "testdashboard",
				data: {
					title: "Test Dashboard",
					applicationItemID: "db65a989-e7cf-4bb1-a4b4-40abcfa9f31b",
				},
				component: TestPageComponent,
				children: TestPageRoutes,
			},
			{
				path: "schoolsearch",
				data: {
					title: "School Search",
					applicationItemID: "db65a989-e7cf-4bb1-a4b4-40abcfa9f31b",
				},
				component: SchoolSearchComponent,
				children: SchoolSearchRoutes,
			},
			{
				path: "student",
				component: StudentComponent,
				children: StudentRoutes,
			},
			{
				path: "classroom",
				component: ClassroomComponent,
				children: ClassroomRoutes,
			},
			{
				path: "staff",
				component: StaffComponent,
				children: StaffRoutes,
			},
			{
				path: "group",
				component: GroupsComponent,
				children: GroupsRoutes,
			},
			{
				path: "report",
				component: ReportComponent,
				children: ReportRoutes,
			},
			{
				path: "idadmin",
				component: IDAdminComponent,
				children: IDAdminRoutes,
			},
			{
				path: "idstation",
				component: IDStationComponent,
				children: IDStationRoutes,
			},
			{
				path: "onecardexpress",
				component: OneCardExpressComponent,
				children: OneCardExpressRoutes,
			},
			{
				path: "visitor",
				component: VisitorComponent,
				children: VisitorRoutes,
			},
			{
				path: "expressidcardprinting",
				component: ExpressIDCardPrintingComponent,
				children: ExpressIDCardPrintingRoutes,
			},
			{
				path: "dynamicreport",
				component: DynamicReportComponent,
				children: DynamicReportRoutes,
			},
			{
				path: "adminsetup",
				component: AdminSetupComponent,
				children: AdminSetupRoutes,
			},
			{
				path: "adminsettings",
				component: SchoolSettingsComponent,
				children: SchoolSettingsRoutes,
			},
			{
				path: "sysadmin",
				component: SysAdminComponent,
				children: SysAdminRoutes,
			},
			{
				path: "siteadmin",
				component: DistrictAdminComponent,
				children: DistrictAdminRoutes,
			},
			{
				path: "admin",
				component: AdminComponent,
				children: AdminRoutes,
			},
			{
				path: "scanpoint",
				component: ScanPointComponent,
				children: ScanPointRoutes,
			},
			{
				path: "section",
				component: SectionComponent,
				children: SectionRoutes,
			},
			{
				path: "bustracker",
				component: BusTrackerComponent,
				children: BusTrackerRoutes,
			},
			{
				path: "hallsweep",
				component: HallSweepComponent,
				children: HallSweepRoutes,
			},
			{
				path: "dashboardvisitor",
				component: DashboardVisitorComponent,
				children: DashboardVisitorRoutes,
			},
			{
				path: "vpp3",
				component: Vpp3Component,
				children: Vpp3Routes,
			},
			{
				path: "multistation",
				component: VisitorMultiStationComponent,
				children: VisitorMultiStationRoutes,
			},
			{
				path: "dashboardmultistation",
				component: DashboardMultiStationComponent,
				children: DashboardMultiStationRoutes,
			},
			{
				path: "inboxreport",
				component: ReportInboxMainComponent,
				children: ReportInboxRoutes,
			},
			{
				path: "portalapps",
				component: PortalAppsComponent,
				children: PortalAppsRoutes,
			},
		],
	},
];

@NgModule({
	imports: [
		ExpressIDCardPrintingModule,
		DashboardModule,
		DashboardMainModule,
		StudentModule,
		ClassroomModule,
		GroupsModule,
		ReportModule,
		IDAdminModule,
		IDStationModule,
		OneCardExpressModule,
		VisitorModule,
		ExpressIDCardPrintingModule,
		DynamicReportModule,
		StaffModule,
		SchoolSettingsModule,
		AdminSetupModule,
		SysAdminModule,
		DistrictAdminModule,
		AdminModule,
		ScanPointModule,
		SectionModule,
		TestPageModule,
		SchoolSearchModule,
		BusTrackerModule,
		HallSweepModule,
		DashboardVisitorModule,
		Vpp3Module,
		VisitorMultiStationModule,
		DashboardMultiStationModule,
		ReportInboxModule,
		PortalAppsModule,
		RouterModule.forRoot(routes),
	],
	exports: [RouterModule],
})
export class MasterRoutingModule {}
